"use client";
import React from "react";
import { Box } from "@chakra-ui/react";
import PageLayout from "@/layouts/pageLayout";
import PrivateCloudTabs from "@/components/pageTabs/privateCloudTabs";
import Faqs from "./components/faqs";
import Hero from "./components/hero";
import Intro from "./components/intro";
import FeaturesComponent from "./components/features";
import Implementation from "./components/implementation";

const EncryptedStorageClustersPage = () => {
  return (
    <Box>
      <Hero />
      <PageLayout showContactForm>
        <PrivateCloudTabs />
        <Intro />
        <FeaturesComponent />
        <Implementation />
        <Faqs />
      </PageLayout>
    </Box>
  );
};

export default EncryptedStorageClustersPage;
